var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemAlertaDesvio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFB642"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 0C12.806 0 14 1.194 14 2.667v8.666C14 12.806 12.806 14 11.333 14H2.667C1.194 14 0 12.806 0 11.333V2.667C0 1.194 1.194 0 2.667 0h8.666zM4.601 2.683c-.048 0-.093.023-.12.062l-1.786 2.54-.023.048c-.009.035-.005.072.012.105.026.049.076.08.132.08h.895v.447l.006.22c.059 1.03.529 1.996 1.309 2.679l.367.32.128.123c.368.383.576.895.576 1.43v.447l.007.047c.02.06.076.102.142.102h1.491l.047-.007c.06-.02.102-.076.102-.142v-.447l-.007-.221c-.06-1.029-.53-1.994-1.308-2.678l-.367-.321-.128-.123C5.708 7.012 5.5 6.5 5.5 5.964v-.447h.895l.04-.005c.04-.011.073-.037.092-.074.025-.05.021-.109-.011-.154l-1.794-2.54-.033-.032c-.026-.019-.056-.029-.088-.029zm4.772 0c-.048 0-.092.023-.12.062l-1.786 2.54-.02.04-.008.044c0 .04.016.078.044.105.028.028.066.043.105.043h.895v.448l-.008.177c-.045.529-.293 1.022-.696 1.375l-.367.32-.112.103-.107.106.028.035.154.196c.345.467.588 1.003.713 1.572.12-.254.29-.48.502-.665l.367-.32.163-.15c.735-.723 1.153-1.713 1.153-2.75v-.447h.894l.04-.005c.04-.011.073-.037.092-.074.025-.05.021-.109-.01-.154l-1.795-2.54-.033-.032c-.025-.019-.056-.029-.088-.029z",
    transform: "translate(-337 -393) translate(22 265) translate(315 128)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemAlertaDesvio);
export default __webpack_public_path__ + "static/media/system-alerta-desvio.bd1c0335.svg";
export { ForwardRef as ReactComponent };